import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, adminOnly = false, requiredPage = "", requiredFlag = "" }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#f5f7fa] flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#3B42DD]" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;

  // Admin has access to everything
  if (user.role === "admin") return children;

  // Check page-level permissions for non-admin users
  if (requiredPage) {
    const allowedPages = user.allowed_pages || [];
    if (!allowedPages.includes(requiredPage)) {
      return <Navigate to="/" replace />;
    }
  }

  // Boolean flag (es. `manage_treatments`): user accede solo se ha il
  // flag attivo (oltre ad essere admin, già gestito sopra).
  if (requiredFlag) {
    if (!user[requiredFlag]) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
}
